import { axiosErrorHandler } from "@acri-tools/react-tools/utils/global"
import request from "@acri-tools/react-tools/utils/request"
import { setProductTypes } from "../actions/product_types"
import store from "../store"
import { API_URL } from "./config"
import { product_types } from "./data"
import { sleep } from "./general"

export const load_product_types = async(refresh?:boolean) =>{
    // if(refresh) this.setState({ loading: true })
    const state = store.getState();
    if(state?.product_types?.product_types) return;
    try {
        let res = await request(`${API_URL}/api/v1/product_types`,{
            method:'get',
            responseType:'json',
            serializer:'json',
            params:{
                orderby: "name ASC",
                limit: 1000
            }
        })
        // store.dispatch(setProductTypes({ product_types: product_types }))
        let product_types_filtered:any = {};
        let product_types:any = {};
        res.data.value.forEach((pt:any) => {
            if(!pt.name?.match(/AX$/))
                product_types[pt.name] = pt.id
            if(["0", "1", "2", "3", "4"].includes(pt.processing_level))
                product_types_filtered[pt.name] = pt.id;
        });
        store.dispatch(setProductTypes({ product_types, product_types_filtered }))
        // await sleep(600)
    }
    catch (e) {
        axiosErrorHandler( e, { 
            functionName: 'fetch_product_types'
        })
    }
    finally {
        // this.setState({ loading: false })
        // if(refresh) this.setState({ loading: false });
    }
}


export const get_product_types = (filtered?:boolean)=>{
    const state = store.getState();
    return filtered ? state.product_types.product_types_filtered : state.product_types.product_types
}

export const get_default_product_type = (filtered?:boolean)=>{
    let product_types = get_product_types(filtered)
    return product_types ? 
            Object.keys(product_types)[0]
        :
            'OL_1_EFR___'
}

export const get_product_type_id = (productType:string)=>{
    const state = store.getState();
    return state.product_types?.product_types?.[productType]
}